'use client';

import Hero from './components/Hero';
import SearchWays from './components/SearchWays';
import Categories from './components/Categories';
import ProsBlock from '@components/sections/ProsBlock';

// Sin «Destacados»: la home no pone a ningún negocio por encima de otro.
export default function Home({ categories, field, works = [] }) {
  return (
    <>
      <Hero categories={categories} />
      <SearchWays field={field} works={works.slice(0, 6)} />
      <Categories categories={categories} />
      <ProsBlock />
    </>
  );
}
